// main.ts
import './assets/index.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import { useAuth } from '@/stores/auth'
import { api } from '@/lib/api'

api.defaults.withCredentials = true
api.defaults.baseURL = '/'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPersist)
app.use(pinia)
app.use(router)

// evita tela branca em runtime
app.config.errorHandler = (err) => {
    console.error(err)
    const el = document.getElementById('app')
    if (el) el.innerHTML = '<div style="padding:24px;font-family:system-ui">Falha ao carregar. Atualize a página.</div>'
}

// monta após router pronto e busca usuário
router.isReady().then(async () => {
    const auth = useAuth(pinia) // fora do setup: passe a instância do pinia
    try {
        await auth.fetchUser()    // ok se 401 (sem derrubar app)
    } catch {}

    document.documentElement.classList.remove('dark')
    document.documentElement.style.colorScheme = 'light'

    app.mount('#app')
})
